import { ActivitySpinnerSize, ActivitySpinnerWidget, FilteringList, FilteringListProps, ListItem } from '@tableau/widgets';
import { DivAttrs } from '@tableau/widgets/lib/src/utils/HtmlAttrs';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

import { CommonStyles } from '../CommonStyles';

export interface FilteringListWithSpinnerProps extends FilteringListProps, Omit<DivAttrs, 'onSelect'> {
  readonly showSpinner?: boolean;
}

export function FilteringListWithSpinner(props: FilteringListWithSpinnerProps): JSX.Element {
  const {showSpinner, ...forwardProps} = props;

  const getListContent = React.useCallback((): ListItem[] => {
    let items: ListItem[] = [];
    if(showSpinner) {
      return [];
    } else if (props.items.length === 0) {
      items.push({ value: Messages.noMatches(), disabled: true, testId: 'no-matches-item' });
    } else {
      items = props.items;
    }
    return items;
  }, [props.items, showSpinner]);

  return <FilteringList
    {...forwardProps}
    children={showSpinner &&
      <div className={spinnerStyle}>
        <ActivitySpinnerWidget
          spinnerSize={ActivitySpinnerSize.Small}
          testId={props.testId}
        />
      </div>
    }
    items={getListContent()}
  />;
}

const spinnerStyle = cssClass('filtering-list', 'spinner', {
  textAlign: 'center',
  paddingTop: CommonStyles.Sizes.MediumSpace
});
